import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { RuoloReferenzaModel } from '../core/models/api/ruolo-referenza.model';

@Injectable({
  providedIn: 'root',
})
export class RuoliReferenzaService {
  apiUrl: string = environment.backend.baseUrl + '/ruoli-referenza';

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {}

  getRuoli(): Observable<RuoloReferenzaModel[]> {
    return this.http.get<RuoloReferenzaModel[]>(this.apiUrl).pipe(
      tap(ruoli => this.logger.debug('[RUOLI-REFERENZA-SERVICE] Ruoli caricati:', ruoli.length)),
      catchError(error => {
        this.logger.error('[RUOLI-REFERENZA-SERVICE] Errore nel caricamento dei ruoli:', error);
        // L'errore deve arrivare al chiamante: vedi nota in RequisitiService.getClienti().
        return throwError(() => error);
      })
    );
  }

  createRuolo(data: { descrizione: string }): Observable<RuoloReferenzaModel> {
    return this.http.post<RuoloReferenzaModel>(this.apiUrl, data).pipe(
      tap(() => this.logger.info('[RUOLI-REFERENZA-SERVICE] Ruolo creato con successo')),
      catchError(error => {
        this.logger.error('[RUOLI-REFERENZA-SERVICE] Errore nella creazione del ruolo:', error);
        throw error;
      })
    );
  }

  updateRuolo(id: number, data: { descrizione: string }): Observable<RuoloReferenzaModel> {
    return this.http.put<RuoloReferenzaModel>(`${this.apiUrl}/${id}`, data).pipe(
      tap(() => this.logger.info('[RUOLI-REFERENZA-SERVICE] Ruolo aggiornato con successo')),
      catchError(error => {
        this.logger.error('[RUOLI-REFERENZA-SERVICE] Errore nell\'aggiornamento del ruolo:', error);
        throw error;
      })
    );
  }

  deleteRuolo(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`).pipe(
      tap(() => this.logger.info('[RUOLI-REFERENZA-SERVICE] Ruolo eliminato con successo')),
      catchError(error => {
        this.logger.error('[RUOLI-REFERENZA-SERVICE] Errore nell\'eliminazione del ruolo:', error);
        throw error;
      })
    );
  }
}
